export const MODULE_NAME = 'pagePreview';
